import { USER_TYPE } from "utils/constants"
/**
 * Core user object
 */
export interface User {
  uuid: string
  canLogin: boolean
  email: string
  emailVerification: boolean
  firstName: string
  lastName: string | null
  lastRole: string
  middleName: string
  photo: string
  roles: string[]
}

export interface AuthData {
  accessToken: string
  expiresIn: number
  refreshToken: string
  scope: string
  tokenType: string
  user: User
}

export type ResendVerificationEmail = {
  email: string
  platform: typeof USER_TYPE
  product: 1
}

export type RefreshTokenResponse = Omit<AuthData, "user">

export enum Product {
  learning = 1,
  school = 2,
  partner = 3,
  internal = 4,
  center = 5,
}
export type GetUserResponse = {
  email: string
  first_name: string
  middle_name: string | null
  last_name: string | null
  isd_code: number | null
  phone_number_verified_at: string | null
  phone_number: { code: number; number: string } | null
  full_name: string
  product: Product.internal
}
